import React from 'react';
import Controls from '@/components/Calendar/Toolbar/Controls';

export default function Toolbar({ label, date, onNavigate }) {
  return <Controls />;
}
